/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import PageConfig from '@msr/Common/PageConfig';
import RenderSections from '@msr/Common/RenderSections';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/msrService';

/**
 *
 * @param {Object} pageData
 * @returns
 */
const CelebrationsArticle = ({ pageData }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang('', 'en');
  }, [authContext, '', 'en']);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      {pageData?.breadcrumbs?.length > 0 && (
        <Breadcrum
          page={pageData.breadcrumbs}
          alsoin={pageData.alsoin}
          url=""
          region={''}
          lang={''}
        />
      )}

      <Box as="section" className="container" p="0">
        {pageData?.body?.length && pageData?.body[0]?.value.length
          ? pageData.body[0]?.value.map((section, i) => {
              return (
                <RenderSections pageData={pageData}
                  section={section}
                  region={''}
                  lang={''}
                  key={nanoid(4)}
                />
              );
            })
          : null}
      </Box>
      <PageConfig
        isLikeVisible={false} pageData={pageData}
      />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const msrPaths = config.USE_LOCAL_URL
    ? [
        `/mahashivratri/celebrations/power-of-the-mantra`,
        `/mahashivratri/celebrations/event-schedule`,
      `/mahashivratri/celebrations/yaksha`,
      `/mahashivratri/celebrations/yaksha-live`,
        `/mahashivratri/celebrations/yaksha-live-two`
      ]
    : await getLandingPaths('L1', '/mahashivratri/celebrations/');
  return {
    paths: msrPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({ preview, previewData, params: { article } }) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('IN', 'en'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('IN', 'en'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', '', `celebrations/${article}`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      menuType: 'msrmainmenu'
    }
  };
};

export default CelebrationsArticle;